import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestAddchgsGetRes } from "./abst/DtoRequestAddchgsGetRes";

export class DtoRequestAddchgsGetResImple extends DtoRequestAddchgsGetRes {
  public pager = new DtoApiPager();
}
